export default "__VITE_PUBLIC_ASSET__fa4e38a3__"